import { render, staticRenderFns } from "./AdvertisersCheckPage.vue?vue&type=template&id=590c9b3c&scoped=true&"
import script from "./AdvertisersCheckPage.vue?vue&type=script&lang=js&"
export * from "./AdvertisersCheckPage.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisersCheckPage.vue?vue&type=style&index=0&id=590c9b3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590c9b3c",
  null
  
)

export default component.exports